import React, { Fragment } from "react";
import { Link } from "react-router-dom";
import { Media } from "reactstrap";
import { H5, Image, P } from "../../../AbstractElements";
import Imageavtar from "../../../assets/images/avtar/chinese.png";
import { Gallery, Item } from "react-photoswipe-gallery";

const Activity3 = () => {
  const image = ["img-26.jpg", "image-20.jpg"];

  return (
    <Fragment>
      <tr>
        <td>
          <Media>
            <div className="square-box me-2">
              <Image attrImage={{ className: "img-fluid b-r-5", src: `${Imageavtar}`, alt: "" }} />
            </div>
            <Media body>
              <Link to={`${process.env.PUBLIC_URL}/user/userprofile`}>
                <H5>Max Simmons attached 2</H5>
              </Link>
              <P>
                photos to <span className="font-primary">Food photography Class</span>
              </P>
              <div className="d-flex">
                <Gallery>
                  {image &&
                    image.map((item, i) => {
                      return (
                        <div className={`inner-img ${i !== 0 ? "ms-3" : ""}`} key={i}>
                          <Item original={require(`../../../assets/images/dashboard/${item}`)} width="1024" height="768">
                            {({ ref, open }) => (
                              <Link onClick={open}>
                                <img className="img-thumbnail img-fluid img-40" ref={ref} src={require(`../../../assets/images/dashboard/${item}`)} alt="" />
                              </Link>
                            )}
                          </Item>
                        </div>
                      );
                    })}
                </Gallery>
              </div>
            </Media>
          </Media>
        </td>
        <td>
          <span className="badge badge-light-theme-light font-theme-light">22 Jun 2022</span>
        </td>
      </tr>
    </Fragment>
  );
};
export default Activity3;
